// Lib
import { SIZE_75 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const videoViewsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.youtube.video_views_history',
    tooltip: 'chart.youtube.tooltip_video_views_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.youtube.video_views_history_name',
        avg: 'chart.youtube.video_views_history_avg'
    },
    id: 'video_views_history',
    color: {
        value: 'purple',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.youtube.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_75,
    type: 'chart',
    element: LineChart
};
